






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {CargaKarcher} from '@/model/resource/CargaKarcher'
import {InputCargaKarcherSchema} from '@/schema/resource/CargaKarcher/InputCargaKarcherSchema'

@Component
export default class PersistCargaKarcherView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputCargaKarcherSchema()
  cargaKarcher = new CargaKarcher()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionCarga.listCarga()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.cargaKarcher.getCargaKarcher(id)
    }

    $.await.done('getCargaKarcher')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.cargaKarcher.persistCargaKarcher()
    await Helper.successAndPush('system.success.persist', '/carga-karcher/list')
  }
}
